import { ligainicial } from "./rutainicial.js";

const ligabase = ligainicial + "2026/Lic/C";

export const licitacionesVigentes = [
    {
        // CONVOCATORIA NUM# 015
        'numConvocatoria' : 'Convocatoria No. 015/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N29-2026.',
        'vigencia' : '25 de mayo al 5 de junio de 2026.',
        'descripcionProcedimiento' : 'Rehabilitación de imagen urbana del boulevard Colosio, primera etapa, en el municipio de Pachuca de Soto.; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligabase }15/N29/N29.rar`,
        'start' : '2026-05-25',
        'end' : '2026-06-05',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N28-2026.',
        'vigencia' : '25 de mayo al 5 de junio de 2026.',
        'descripcionProcedimiento' : 'Construcción y rehabilitación de espacios en el Centro de Rehabilitación Integral Regional Hidalgo (CRIRH), ubicado en el municipio de Ixmiquilpan.; ubicada en la localidad de EL TEPHÉ, Municipio de Ixmiquilpan, Estado de Hidalgo',
        'urlAnexos' : `${ ligabase }15/N28/N28.rar`,
        'start' : '2026-05-25',
        'end' : '2026-06-05',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N27-2026.',
        'vigencia' : '25 de mayo al 5 de junio de 2026.',
        'descripcionProcedimiento' : 'Rehabilitación integral de acceso principal y caseta de control de acceso a instalaciones del Sistema DIF Hidalgo, ubicado en Pachuca de Soto, Hidalgo; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo',
        'urlAnexos' : `${ ligabase }15/N27/N27.rar`,
        'start' : '2026-05-25',
        'end' : '2026-06-05',
        'procedimiento' : 'Licitación Pública',
    },
    {
        // CONVOCATORIA NUM# 014
        'numConvocatoria' : 'Convocatoria No. 014/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N26-2026.',
        'vigencia' : '18 al 29 de mayo de 2026.',
        'descripcionProcedimiento' : 'Reconstrucción de avenida Tecnológico de Monterrey, en el municipio de Pachuca de Soto; ubicada en la localidad y Municipio de Pachuca de Soto, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }14/N26/N26.rar`,
        'start' : '2026-05-18',
        'end' : '2026-05-29',
        'procedimiento' : 'Licitación Pública',
    },
    {
        // CONVOCATORIA NUM# 013
        'numConvocatoria' : 'Convocatoria No. 013/2026.',
        'numProcedimiento' : 'EO-SIPDUS-N25-2026.',
        'vigencia' : '18 al 29 de mayo de 2026.',
        'descripcionProcedimiento' : 'Análisis, estudio y proyecto para obras de protección del Río Rosas, en el municipio de Tula de Allende; ubicado en la localidad y Municipio de Tula de Allende, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }13/N25/N25.rar`,
        'start' : '2026-05-18',
        'end' : '2026-05-29',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N24-2026.',
        'vigencia' : '18 al 29 de mayo de 2026.',
        'descripcionProcedimiento' : 'Elaboración de estudio de socavación en Río Tula en tramo de colector revestido entre los km 3+400 - 3+800, en el municipio de Tula de Allende; ubicado en la localidad y Municipio de Tula de Allende, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }13/N24/N24.rar`,
        'start' : '2026-05-18',
        'end' : '2026-05-29',
        'procedimiento' : 'Licitación Pública',
    },
    {
        'numProcedimiento' : 'EO-SIPDUS-N23-2026.',
        'vigencia' : '18 al 29 de mayo de 2026.',
        'descripcionProcedimiento' : 'Rehabilitación de Inmueble para Construcción del Centro Social y Cultural en el municipio de Progreso de Obregón.; ubicada en la localidad y Municipio de Progreso de Obregón, Estado de Hidalgo.',
        'urlAnexos' : `${ ligabase }13/N23/N23.rar`,
        'start' : '2026-05-18',
        'end' : '2026-05-29',
        'procedimiento' : 'Licitación Pública',
    },
]